import { Button, Flex, SimpleGrid, Title } from "@mantine/core";
import ProductCartItem from "../../components/ProductCartItem/ProductCartItem";
import useProductManager from "../../hooks/useProductManager";
import { RoutePaths } from "../../router";

export default function MainPageLatestProduct() {
  const { data: products, isLoading: isProductsLoading } =
    useProductManager().getAllProducts({ limit: 12 });

  const handleShowAllProducts = () => {
    window.location.href = `${RoutePaths.Product}`;
  };

  return (
    <div className="main-page-latest-product flex flex-col gap-4">
      {/* Header */}
      <div className="px-4 pt-4">
        <Title order={3}>Sản phẩm mới về</Title>
      </div>

      <SimpleGrid
        cols={{ xl: 6, md: 4, base: 2, sm: 3 }}
        spacing={{ base: 4, sm: 6, md: 12, xl: 14 }}
      >
        {!isProductsLoading &&
          products &&
          products.items.map((product) => (
            <ProductCartItem key={product.id} product={product} />
          ))}
      </SimpleGrid>

      <Flex justify={`center`} align={`center`}>
        <Button variant="outline" color="black" onClick={handleShowAllProducts}>
          Xem tất cả
        </Button>
      </Flex>
    </div>
  );
}
